import React from 'react';

import {Button, Dialogue, Heading, Icon, Modal, Text} from '@albert-io/atomic';

interface Props {
  restrictedCount: number;
  isSubmitting?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

// Arbitrary value: no 40px typography token exists for the design's shield size.
const SHIELD_ICON_CLASS_NAME = 'text-[40px]';

// Restriction is informational, not blocking; drafts and already-published edits are not gated (at call site).
export function RestrictedQuestionsPublishModal({
  restrictedCount,
  isSubmitting,
  onCancel,
  onConfirm
}: Props) {
  const countNoun = restrictedCount === 1 ? 'question' : 'questions';
  const verb = restrictedCount === 1 ? 'is' : 'are';
  const pronoun = restrictedCount === 1 ? 'this question' : 'these questions';

  return (
    <Modal ariaLabel='Restricted questions in this assignment' handleClose={onCancel}>
      {() => (
        <Dialogue inModal size='m' handleClose={onCancel}>
          <Dialogue.Body align='center'>
            <div className='flex flex-col items-center gap-x2'>
              <Icon
                icon='shield'
                iconStyle='solid'
                color='warning'
                size='inherit'
                className={SHIELD_ICON_CLASS_NAME}
              />
              <Heading as='h2' size='m'>
                {`${restrictedCount} restricted ${countNoun} ${verb} in this assignment`}
              </Heading>
              <div className='flex flex-col gap-x1'>
                <Text>
                  {`Your students won't be able to access ${pronoun} unless an admin at your school grants authorization for this assignment.`}
                </Text>
                <Text size='s' color='secondary'>
                  You can publish the assignment now and request authorization from your admin
                  separately.
                </Text>
              </div>
            </div>
          </Dialogue.Body>
          <Dialogue.BtnGroup align='right'>
            <Button color='secondary' onClick={onCancel} disabled={isSubmitting}>
              Cancel
            </Button>
            <Button onClick={onConfirm} disabled={isSubmitting}>
              Publish anyway
            </Button>
          </Dialogue.BtnGroup>
        </Dialogue>
      )}
    </Modal>
  );
}

export default RestrictedQuestionsPublishModal;
